export type IcNavButtonModes = "navbar" | "menu";
